import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Divider, Typography } from '@material-ui/core';
import 'typeface-roboto';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
    marginLeft: 15
  },
  // This group of buttons will be aligned to the right
  rightToolbar: {
    marginLeft: 'auto',
    marginRight: -12,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  appbar: {
    backgroundColor: '#346994'  // grey[800]
  },
  button: {
    marginLeft: theme.spacing(15),
  },
  img_embrapa: {
    width: '7rem',
    marginLeft: '8px',
    marginRight: '8px',
  },
  img_bayer: {
    height: '3rem',
    width: '3rem',
    marginLeft: '8px',
    marginRight: '8px',
  },

}));

export const Header: React.FC = () => {
  localStorage.clear();
  const classes = useStyles();

  return (

    <div className={classes.root}>

      <AppBar position="static" className={classes.appbar} >
        <Toolbar variant="dense">
          <img src='assets/images/plant.png' alt='' width='30px' style={{ color: 'white' }} />
          <Typography variant="h4" color="inherit" className={classes.flex}>
            Plantas Daninhas Resistentes a Herbicidas
          </Typography>
          <Divider orientation="vertical" flexItem />
          <img src='assets/images/embrapa.png' alt='' className={classes.img_embrapa} />
          <img src='assets/images/bayer.png' alt='' className={classes.img_bayer} />
        </Toolbar>
      </AppBar>

    </div>

  );

}